var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("Home Page")]),_c('v-card-subtitle',[_vm._v("Quick access to various programs")]),_c('v-card-actions',[_c('ProgramList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }